import { useState, useEffect } from "react"
import OutsideClickTrigger from "../../../../booking/components/common/OutsideClickTrigger"
import Svg from "../../../_svgs/svg"

const ToggleInfo = ({ description, id, closeModalLabel, moreInfoLabel }) => {
  const [toggleInfoActive, setToggleInfoActive] = useState(false)

  const handleToggleInfo = (e) => {
    if (e) e.preventDefault()

    setToggleInfoActive(!toggleInfoActive)
  }

  const handleBlur = (e) => {
    if (e) e.preventDefault()
    setToggleInfoActive(false)
  }

  const handleCloseAndRefocusInput = (e) => {
    e.preventDefault()
    setToggleInfoActive(false)
    document.getElementById(id).focus()
  }

  useEffect(() => {
    if (!toggleInfoActive) return

    const handleScroll = () => {
      setToggleInfoActive(false)
    }

    window.addEventListener("scroll", handleScroll, { passive: true })

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [toggleInfoActive])

  if (!description) return null

  return (
    <OutsideClickTrigger onOutsideClick={(e) => setToggleInfoActive(e)}>
      <div className="form-info-toggle-wrapper">
        <button aria-label={moreInfoLabel} className="form-info-toggle" onClick={(e) => handleToggleInfo(e)} aria-expanded={toggleInfoActive}>
          <Svg iconName="Info-Icon" isDecorative={true} />
        </button>
        {toggleInfoActive && (
          <div className={`form-info-toggle-content ${toggleInfoActive ? "active" : ""}`}>
            <p>{description}</p>
            <button
              aria-label={closeModalLabel}
              className="form-info-close-button"
              onBlur={(e) => handleBlur(e)}
              onClick={(e) => handleCloseAndRefocusInput(e)}
            >
              <Svg iconName="close" />
            </button>
          </div>
        )}
      </div>
    </OutsideClickTrigger>
  )
}

export default ToggleInfo
